const DEFAULT_ADSENSE_CLIENT = "ca-pub-7348958274412490";
const DEFAULT_DISPLAY_SLOT = "8586392052";
const DEFAULT_VERTICAL_SLOT = "8586392052";
const DEFAULT_IN_ARTICLE_SLOT = "7961387705";
const DEFAULT_IN_FEED_SLOT = "3876990859";
const DEFAULT_MULTIPLEX_HORIZONTAL_SLOT = "5734679614";
const DEFAULT_MULTIPLEX_VERTICAL_SLOT = "5960228712";

export const ADSENSE_CLIENT =
  process.env.REACT_APP_ADSENSE_CLIENT || DEFAULT_ADSENSE_CLIENT;

export const ADSENSE_DISPLAY_SLOT =
  process.env.REACT_APP_ADSENSE_DISPLAY_SLOT || DEFAULT_DISPLAY_SLOT;

export const ADSENSE_VERTICAL_SLOT =
  process.env.REACT_APP_ADSENSE_VERTICAL_SLOT || DEFAULT_VERTICAL_SLOT;

export const ADSENSE_IN_ARTICLE_SLOT =
  process.env.REACT_APP_ADSENSE_IN_ARTICLE_SLOT || DEFAULT_IN_ARTICLE_SLOT;

export const ADSENSE_IN_FEED_SLOT =
  process.env.REACT_APP_ADSENSE_IN_FEED_SLOT || DEFAULT_IN_FEED_SLOT;

export const ADSENSE_MULTIPLEX_HORIZONTAL_SLOT =
  process.env.REACT_APP_ADSENSE_MULTIPLEX_HORIZONTAL_SLOT ||
  DEFAULT_MULTIPLEX_HORIZONTAL_SLOT;

export const ADSENSE_MULTIPLEX_VERTICAL_SLOT =
  process.env.REACT_APP_ADSENSE_MULTIPLEX_VERTICAL_SLOT ||
  DEFAULT_MULTIPLEX_VERTICAL_SLOT;

// Backward-compatible alias used by older components.
export const ADSENSE_MULTIPLEX_SLOT =
  process.env.REACT_APP_ADSENSE_MULTIPLEX_SLOT ||
  ADSENSE_MULTIPLEX_HORIZONTAL_SLOT;

export const ADSENSE_TEST_MODE =
  String(process.env.REACT_APP_ADSENSE_TEST_MODE || "").toLowerCase() === "true";

export function isAdSenseHostAllowed() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h !== "localhost" && h !== "127.0.0.1";
}
